import { css, styled } from "@mui/material";

export const ProjectsGroupOuterContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;

    ${theme.breakpoints.up("mobile")} {
      gap: 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      gap: 24px;
    }

    ${theme.breakpoints.up("desktop")} {
      gap: 32px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      gap: 40px;
    }
  `,
);

export const ProjectsGroupInnerContainer = styled("div")(
  ({ theme }) => css`
    display: grid;

    ${theme.breakpoints.up("mobile")} {
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }

    ${theme.breakpoints.up("desktop")} {
      gap: 32px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      gap: 40px;
    }
  `,
);
